import {Injectable, inject, signal} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {firstValueFrom, isObservable, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PdfViewerService {
  sanitizer = inject(DomSanitizer);
  blobUrl = signal<string | null>(null);
  visible = signal(false);

  viewPdf(source: Blob | Promise<Blob> | Observable<Blob>): void {
    this.close();
    this.visible.set(true);

    const setBlob = (blob: Blob) => {
      const url = URL.createObjectURL(blob);
      const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.blobUrl.set(safeUrl as string);
    };

    if (source instanceof Blob) {
      setBlob(source);
    } else if (isObservable(source)) {
      firstValueFrom(source).then((blob) => setBlob(blob as Blob)).catch(() => this.close());
    } else {
      source.then((blob) => setBlob(blob)).catch(() => this.close());
    }
  }

  close(): void {
    this.visible.set(false);
    const url = this.blobUrl();
    if (url) {
      URL.revokeObjectURL(url);
      this.blobUrl.set(null);
    }
  }
}
